"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.StyledMediaButtonContent = exports.StyledThumbScrollerButton = exports.Scroller = exports.ThumbnailRoot = exports.CubeHolder = exports.CaptionHolder = exports.StyledMedia = exports.CaptionText = exports.Caption = exports.ImageWrapper = exports.MediaGalleryRoot = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Media_1 = __importDefault(require("../media/Media"));
const thumb_scroller_button_1 = __importDefault(require("../thumb-scroller-button"));
const Typography_1 = __importDefault(require("../typography/Typography"));
const MediaButton_1 = __importDefault(require("./MediaButton/MediaButton"));
const PREFIX = "MediaGallery";
exports.classes = {
    mainImageWrapperCover: `${PREFIX}-mainImageWrapperCover`,
    mainImageWrapperdefault: `${PREFIX}-mainImageWrapperdefault`,
    mainImageWrappershort: `${PREFIX}-mainImageWrappershort`,
    visualiserSlide: `${PREFIX}-visualiserSlide`,
    thumbnail: `${PREFIX}-thumbnail`,
    touch: `${PREFIX}-touch`,
    leftGradient: `${PREFIX}-leftGradient`,
    rightGradient: `${PREFIX}-rightGradient`,
    mobileScroller: `${PREFIX}-mobileScroller`
};
exports.MediaGalleryRoot = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "block",
    position: "relative",
    [`.${exports.classes.visualiserSlide}`]: {
        cursor: "pointer",
        "&::after": {
            content: "''",
            background: theme.colours.black,
            opacity: 0.65,
            position: "absolute",
            zIndex: 1,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    }
}));
exports.ImageWrapper = (0, styles_1.styled)("div")({ position: "relative" });
exports.Caption = (0, styles_1.styled)("div")({
    position: "absolute",
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2,
    "&::after": {
        content: "''",
        position: "absolute",
        right: 0,
        bottom: 0,
        left: 0,
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.75) 40%, rgba(0, 0, 0, 0) 100%)`,
        height: "100px",
        zIndex: 0
    }
});
exports.CaptionText = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.colours.white,
    height: "48px",
    margin: "16px",
    position: "relative",
    zIndex: 2,
    overflow: "hidden"
}));
exports.StyledMedia = (0, styles_1.styled)(Media_1.default)(({ theme }) => ({
    overflow: "hidden",
    maxHeight: "360px",
    height: "calc(100vw - (16px * 2))",
    objectFit: "contain",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundColor: theme.colours.white,
    WebkitPrintColorAdjust: "exact",
    [`&.${exports.classes.mainImageWrapperCover}`]: {
        objectFit: "cover"
    },
    [`&.${exports.classes.mainImageWrapperdefault}`]: {
        [theme.breakpoints.down("lg")]: {
            height: "500px !important",
            maxHeight: "none",
            [theme.breakpoints.down("sm")]: {
                height: "calc(100vw - 32px) !important",
                maxHeight: "500px"
            }
        },
        [theme.breakpoints.up("lg")]: {
            height: "600px !important",
            maxHeight: "none"
        }
    },
    [`&.${exports.classes.mainImageWrappershort}`]: {
        [theme.breakpoints.up("sm")]: {
            height: "360px !important",
            maxHeight: "none"
        },
        [theme.breakpoints.up("md")]: {
            height: "440px !important"
        }
    }
}));
exports.CaptionHolder = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    color: theme.colours.white,
    width: "100%",
    [theme.breakpoints.up("lg")]: {
        maxWidth: "70%"
    }
}));
exports.CubeHolder = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "94px",
    height: "76px",
    borderRadius: "5px",
    background: theme.colours.accent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}));
exports.ThumbnailRoot = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "8px",
    height: "94px",
    width: "100%",
    overflowX: "hidden",
    position: "relative",
    [`&.${exports.classes.touch}`]: {
        overflowX: "scroll",
        position: "static",
        "&::before, &::after": {
            content: "''",
            position: "absolute",
            width: "75px",
            height: "66px",
            zIndex: 2,
            opacity: 0,
            transition: "opacity ease-in-out 0.25s",
            bottom: "-1px",
            pointerEvents: "none"
        },
        "&::before": {
            left: "-1px",
            background: `linear-gradient(to right, ${theme.colours.white} 10%, ${theme.colours.white}00 100%)`
        },
        "&::after": {
            right: "-1px",
            background: `linear-gradient(to left, ${theme.colours.white} 10%, ${theme.colours.white}00 100%)`
        }
    },
    [`&.${exports.classes.leftGradient}`]: {
        "&::before": {
            opacity: 1
        }
    },
    [`&.${exports.classes.rightGradient}`]: {
        "&::after": {
            opacity: 1
        }
    },
    [`.${exports.classes.thumbnail}`]: {
        marginRight: "4px !important",
        flexShrink: 0,
        height: "60px !important",
        position: "relative",
        width: "92px !important",
        zIndex: 1,
        "&:first-of-type": {
            marginRight: "2px !important"
        },
        [theme.breakpoints.up("lg")]: {
            width: "130px !important",
            height: "90px !important"
        }
    },
    [theme.breakpoints.down("lg")]: {
        height: "64px"
    }
}));
exports.Scroller = (0, styles_1.styled)("div")({
    position: "absolute",
    top: 0,
    minWidth: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    transition: "right ease-in-out 0.5s",
    overflowX: "auto",
    "-ms-overflow-style": "none", // hide scrollbar for IE, Edge
    "scrollbar-width": "none", // hide scrollbar for Firefox
    "::-webkit-scrollbar": {
        display: "none" //hide scrollbar for Chrome, Safari, and Opera
    },
    [`&.${exports.classes.mobileScroller}`]: {
        position: "static",
        top: "unset"
    }
});
exports.StyledThumbScrollerButton = (0, styles_1.styled)(thumb_scroller_button_1.default)({
    position: "absolute",
    height: "100%",
    top: 0,
    zIndex: 2,
    opacity: 1,
    transition: "opacity ease-in-out 0.25s"
});
exports.StyledMediaButtonContent = (0, styles_1.styled)(MediaButton_1.default)({
    marginBottom: "12px"
});
exports.Tag = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    left: 0,
    top: "18px",
    zIndex: 2,
    [theme.breakpoints.down("lg")]: {
        top: "12px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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